import { jsxs as l, jsx as c, Fragment as t } from "react/jsx-runtime";
const d = ({ ext: h, className: i = "h-6 w-6", style: F }) => h === "txt" ? /* @__PURE__ */ l(
  "svg",
  {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    className: i,
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#576D7E",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M132.784,311.472H110.4c-11.136,0-11.136-16.368,0-16.368h60.512c11.392,0,11.392,16.368,0,16.368 h-21.248v64.592c0,11.12-16.896,11.392-16.896,0v-64.592H132.784z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M224.416,326.176l22.272-27.888c6.656-8.688,19.568,2.432,12.288,10.752 c-7.68,9.088-15.728,18.944-23.424,29.024l26.112,32.496c7.024,9.6-7.04,18.816-13.952,9.344l-23.536-30.192l-23.152,30.832 c-6.528,9.328-20.992-1.152-13.68-9.856l25.696-32.624c-8.048-10.096-15.856-19.936-23.664-29.024 c-8.064-9.6,6.912-19.44,12.784-10.48L224.416,326.176z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M298.288,311.472H275.92c-11.136,0-11.136-16.368,0-16.368h60.496c11.392,0,11.392,16.368,0,16.368 h-21.232v64.592c0,11.12-16.896,11.392-16.896,0V311.472z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : ["doc", "docx"].includes(h) ? /* @__PURE__ */ l(
  "svg",
  {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    className: i,
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#50BEE8",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M92.576,384c-4.224,0-8.832-2.32-8.832-7.936v-72.656c0-4.608,4.608-7.936,8.832-7.936h29.296 c58.464,0,57.168,88.528,1.136,88.528H92.576z M100.64,311.072v57.312h21.232c34.544,0,36.064-57.312,0-57.312H100.64z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M228,385.28c-23.664,1.024-48.24-14.72-48.24-46.064c0-31.472,24.56-46.944,48.24-46.944 c22.384,1.136,45.792,16.624,45.792,46.944C273.792,369.552,250.384,385.28,228,385.28z M226.592,308.912 c-14.336,0-29.936,10.112-29.936,30.32c0,20.096,15.616,30.336,29.936,30.336c14.72,0,30.448-10.24,30.448-30.336 C257.04,319.008,241.312,308.912,226.592,308.912z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M288.848,339.088c0-24.688,15.488-45.92,44.912-45.92c11.136,0,19.968,3.328,29.296,11.392 c3.456,3.184,3.84,8.816,0.384,12.4c-3.456,3.056-8.704,2.688-11.776-0.384c-5.232-5.504-10.608-7.024-17.904-7.024 c-19.696,0-29.152,13.952-29.152,29.552c0,15.872,9.328,30.448,29.152,30.448c7.296,0,14.08-2.96,19.968-8.192 c3.952-3.072,9.456-1.552,11.76,1.536c2.048,2.816,3.056,7.552-1.408,12.016c-8.96,8.336-19.696,10-30.336,10 C302.8,384.912,288.848,363.776,288.848,339.088z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : ["ppt", "pptx"].includes(h) ? /* @__PURE__ */ l(
  "svg",
  {
    style: F,
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#F15642",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M105.456,303.152c0-4.224,3.328-8.832,8.688-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48 c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.568,8.816-8.176,8.816c-4.224,0-8.688-3.184-8.688-8.816v-72.032 H105.456z M122.336,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H122.336z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M191.616,303.152c0-4.224,3.328-8.832,8.704-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48 c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.704-3.184-8.704-8.816V303.152z M208.496,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H208.496z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M301.68,311.472h-22.368c-11.136,0-11.136-16.368,0-16.368h60.496c11.392,0,11.392,16.368,0,16.368 h-21.232v64.608c0,11.12-16.896,11.392-16.896,0V311.472z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : ["xls", "xlsx", "csv"].includes(h) ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#84BD5A",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M144.336,326.192l22.256-27.888c6.656-8.704,19.584,2.416,12.288,10.736 c-7.664,9.088-15.728,18.944-23.408,29.04l26.096,32.496c7.04,9.6-7.024,18.8-13.936,9.328l-23.552-30.192l-23.152,30.848 c-6.528,9.328-20.992-1.152-13.696-9.856l25.712-32.624c-8.064-10.112-15.872-19.952-23.664-29.04 c-8.048-9.6,6.912-19.44,12.8-10.464L144.336,326.192z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M197.36,303.152c0-4.224,3.584-7.808,8.064-7.808c4.096,0,7.552,3.6,7.552,7.808v64.096h34.8 c12.528,0,12.8,16.752,0,16.752H205.44c-4.48,0-8.064-3.184-8.064-7.792v-73.056H197.36z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M272.032,314.672c2.944-24.832,40.416-29.296,58.08-15.728c8.704,7.024-0.512,18.16-8.192,12.528 c-9.472-6-30.96-8.816-33.648,4.464c-3.456,20.992,52.192,8.976,51.296,43.008c-0.896,32.496-47.968,33.248-65.632,18.672 c-4.24-3.456-4.096-9.072-1.792-12.544c3.328-3.312,7.024-4.464,11.392-0.88c10.48,7.152,37.488,12.528,39.392-5.648 C321.28,339.632,268.064,351.008,272.032,314.672z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "pdf" ? /* @__PURE__ */ c(t, { children: /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#F15642",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M101.744,303.152c0-4.224,3.328-8.832,8.688-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48 c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.688-3.184-8.688-8.816V303.152z M118.624,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H118.624z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M196.656,384c-4.224,0-8.832-2.304-8.832-7.92v-72.672c0-4.592,4.608-7.936,8.832-7.936h29.296 c58.464,0,57.184,88.528,1.152,88.528H196.656z M204.72,311.088V368.4h21.232c34.544,0,36.08-57.312,0-57.312H204.72z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M303.872,312.112v20.336h32.624c4.608,0,9.216,4.608,9.216,9.072c0,4.224-4.608,7.68-9.216,7.68 h-32.624v26.864c0,4.48-3.184,7.92-7.664,7.92c-5.632,0-9.072-3.44-9.072-7.92v-72.672c0-4.592,3.456-7.936,9.072-7.936h44.912 c5.632,0,8.96,3.344,8.96,7.936c0,4.096-3.328,8.704-8.96,8.704h-37.248V312.112z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) }) : h === "mp3" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.616,14.4,32,32,32h320c17.6,0,32-14.384,32-32V128L352,0H128z "
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#50BEE8",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M117.184,327.84v47.344c0,5.632-4.592,8.832-9.216,8.832c-4.096,0-7.664-3.2-7.664-8.832v-72.032 c0-6.64,5.632-8.832,7.664-8.832c3.712,0,5.888,2.192,8.064,4.608l28.16,38l29.152-39.408c4.24-5.248,14.592-3.2,14.592,5.632 v72.032c0,5.632-3.6,8.832-7.68,8.832c-4.592,0-8.192-3.2-8.192-8.832V327.84l-21.232,26.88c-4.592,5.632-10.352,5.632-14.576,0 L117.184,327.84z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M210.288,303.152c0-4.224,3.328-8.832,8.704-8.832h29.552c16.64,0,31.616,11.136,31.616,32.496 c0,20.224-14.976,31.472-31.616,31.472h-21.36v16.896c0,5.632-3.584,8.832-8.192,8.832c-4.224,0-8.704-3.2-8.704-8.832V303.152z M227.168,310.448v31.856h21.36c8.576,0,15.36-7.552,15.36-15.488c0-8.96-6.784-16.368-15.36-16.368L227.168,310.448 L227.168,310.448z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M322.064,311.472h-21.872c-10.736,0-10.096-15.984,0-15.984h39.152c7.792,0,11.376,8.96,5.632,14.72 l-21.232,19.824c15.616-1.152,27.888,10.48,27.888,24.816c0,15.728-11.136,29.168-34.544,29.168 c-10.24,0-20.336-4.224-26.224-13.44c-6.144-9.072,7.024-17.776,13.936-8.832c3.328,4.352,8.704,6.528,14.448,6.528 c7.808,0,15.488-3.328,15.488-13.44c0-13.296-16.256-11.248-25.072-10.352c-10.752,2.048-13.936-9.6-7.664-14.448L322.064,311.472z "
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "mp4" ? /* @__PURE__ */ l(
  "svg",
  {
    version: "1.1",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    fill: "#000000",
    className: i,
    children: [
      /* @__PURE__ */ c("g", { id: "SVGRepo_bgCarrier", strokeWidth: "0" }),
      /* @__PURE__ */ c(
        "g",
        {
          id: "SVGRepo_tracerCarrier",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ l("g", { id: "SVGRepo_iconCarrier", children: [
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#E9E9E0",
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FF5364",
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          " ",
          /* @__PURE__ */ l("g", { children: [
            " ",
            /* @__PURE__ */ c(
              "path",
              {
                fill: "#FFFFFF",
                d: "M22.4,42.924h1.668V53H22.4v-6.932l-2.256,5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668 l2.994,6.891L22.4,42.924z"
              }
            ),
            " ",
            /* @__PURE__ */ c(
              "path",
              {
                fill: "#FFFFFF",
                d: "M28.211,53H26.57V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M28.211,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H28.211z"
              }
            ),
            " ",
            /* @__PURE__ */ c(
              "path",
              {
                fill: "#FFFFFF",
                d: "M38.479,50.648h-4.361V49.35l4.361-6.426h1.668v6.426h1.053v1.299h-1.053V53h-1.668V50.648z M38.479,49.35v-4.512L35.58,49.35H38.479z"
              }
            ),
            " "
          ] }),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#C8BDB8",
              d: "M24.5,28c-0.166,0-0.331-0.041-0.481-0.123C23.699,27.701,23.5,27.365,23.5,27V13 c0-0.365,0.199-0.701,0.519-0.877c0.321-0.175,0.71-0.162,1.019,0.033l11,7C36.325,19.34,36.5,19.658,36.5,20 s-0.175,0.66-0.463,0.844l-11,7C24.874,27.947,24.687,28,24.5,28z M25.5,14.821v10.357L33.637,20L25.5,14.821z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#C8BDB8",
              d: "M28.5,35c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S36.771,35,28.5,35z M28.5,7 c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S35.668,7,28.5,7z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "polygon",
            {
              fill: "#D9D7CA",
              points: "37.5,0.151 37.5,12 49.349,12 "
            }
          ),
          " "
        ] }),
        " "
      ] })
    ]
  }
) : h === "avi" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#F15642",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M121.408,384.016c-4.096-2.32-6.656-6.912-4.096-12.288l36.72-71.76 c3.456-6.784,12.656-7.04,15.856,0l36.08,71.76c5.248,9.968-10.24,17.904-14.848,7.92l-5.632-11.248h-47.2l-5.488,11.264 C130.752,384.016,126.016,384.912,121.408,384.016z M176.416,351.52l-14.464-31.6l-15.728,31.6H176.416z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M241.6,378.256l-33.776-70.736c-4.992-10.112,10.112-18.416,15.728-7.808l11.392,25.712 l14.704,33.76l14.448-33.76l11.392-25.712c5.12-9.712,19.952-3.584,15.616,7.04l-32.624,71.504 C255.536,386.32,246.448,388.24,241.6,378.256z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M306.88,303.152c0-10.48,16.896-10.88,16.896,0v73.04c0,10.624-16.896,10.88-16.896,0V303.152z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "wmv" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#84BD5A",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M153.216,353.44l19.056-52.72c3.824-10.336,19.312-5.504,15.472,5.632l-25.328,68.72 c-2.304,7.28-4.464,9.472-8.832,9.472c-4.592,0-6.016-2.832-8.56-7.44l-22.256-50.544l-21.232,49.776 c-2.32,5.36-4.464,8.432-9.088,8.432c-4.464,0-6.784-3.072-8.816-8.704l-24.816-69.728c-3.84-11.504,12.4-15.712,15.712-5.632 l18.944,52.72l22.656-52.72c3.056-7.792,11.12-8.192,14.432-0.368L153.216,353.44z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M219.744,327.84v47.344c0,5.632-4.608,8.816-9.2,8.816c-4.096,0-7.68-3.184-7.68-8.816v-72.032 c0-6.656,5.648-8.832,7.68-8.832c3.696,0,5.872,2.176,8.048,4.608l28.16,38l29.152-39.408c4.24-5.248,14.592-3.2,14.592,5.632 v72.032c0,5.632-3.6,8.816-7.68,8.816c-4.592,0-8.192-3.184-8.192-8.816V327.84l-21.232,26.88c-4.592,5.632-10.352,5.632-14.576,0 L219.744,327.84z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M339.776,378.256L306,307.504c-4.992-10.096,10.112-18.4,15.728-7.792l11.392,25.696l14.704,33.776 l14.448-33.776l11.392-25.696c5.12-9.728,19.952-3.584,15.616,7.04l-32.624,71.504C353.712,386.32,344.64,388.224,339.776,378.256z "
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "aac" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#F15642",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M88.368,384c-4.096-2.304-6.656-6.912-4.096-12.288l36.72-71.744c3.456-6.784,12.656-7.04,15.856,0 l36.08,71.744c5.248,9.984-10.24,17.904-14.848,7.936l-5.632-11.248h-47.2l-5.52,11.248C97.712,384,92.992,384.912,88.368,384z M143.392,351.52l-14.464-31.616l-15.744,31.616H143.392z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M189.184,384c-4.096-2.304-6.656-6.912-4.096-12.288l36.704-71.744 c3.456-6.784,12.672-7.04,15.872,0l36.064,71.744c5.248,9.984-10.24,17.904-14.832,7.936l-5.648-11.248h-47.2l-5.504,11.248 C198.512,384,193.776,384.912,189.184,384z M244.192,351.52l-14.448-31.616l-15.728,31.616H244.192z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M282.416,339.088c0-24.688,15.488-45.904,44.912-45.904c11.136,0,19.952,3.312,29.296,11.376 c3.456,3.184,3.84,8.832,0.384,12.4c-3.456,3.056-8.704,2.688-11.76-0.368c-5.248-5.504-10.624-7.024-17.92-7.024 c-19.696,0-29.168,13.936-29.168,29.536c0,15.872,9.344,30.464,29.168,30.464c7.296,0,14.08-2.96,19.952-8.192 c3.968-3.072,9.472-1.552,11.776,1.536c2.048,2.816,3.056,7.536-1.408,12.016c-8.96,8.336-19.696,9.984-30.336,9.984 C296.368,384.912,282.416,363.792,282.416,339.088z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "ps" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#F7B84E",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M149.696,303.152c0-4.224,3.328-8.848,8.704-8.848h29.552c16.64,0,31.616,11.136,31.616,32.496 c0,20.224-14.976,31.472-31.616,31.472h-21.36v16.896c0,5.648-3.584,8.832-8.192,8.832c-4.224,0-8.704-3.184-8.704-8.832V303.152z M166.592,310.432v31.856h21.36c8.576,0,15.36-7.552,15.36-15.488c0-8.96-6.784-16.368-15.36-16.368L166.592,310.432 L166.592,310.432z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M234.032,314.656c2.944-24.816,40.416-29.28,58.08-15.712c8.704,7.024-0.512,18.16-8.192,12.528 c-9.472-6.016-30.96-8.832-33.648,4.464c-3.456,20.992,52.192,8.976,51.296,42.992c-0.896,32.496-47.968,33.264-65.632,18.672 c-4.24-3.44-4.096-9.056-1.792-12.528c3.328-3.312,7.024-4.464,11.392-0.896c10.48,7.168,37.488,12.544,39.392-5.648 C283.28,339.616,230.064,351.008,234.032,314.656z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "psd" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#50BEE8",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M100,303.152c0-4.224,3.328-8.848,8.688-8.848h29.552c16.64,0,31.616,11.136,31.616,32.496 c0,20.224-14.976,31.472-31.616,31.472h-21.36v16.896c0,5.648-3.584,8.832-8.192,8.832c-4.224,0-8.688-3.184-8.688-8.832V303.152z M116.88,310.432v31.856h21.36c8.576,0,15.36-7.552,15.36-15.488c0-8.96-6.784-16.368-15.36-16.368L116.88,310.432L116.88,310.432z "
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M184.32,314.656c2.944-24.816,40.416-29.28,58.08-15.712c8.704,7.024-0.512,18.16-8.192,12.528 c-9.472-6.016-30.96-8.832-33.648,4.464c-3.456,20.992,52.192,8.976,51.296,42.992c-0.896,32.496-47.968,33.264-65.632,18.672 c-4.24-3.44-4.096-9.056-1.792-12.528c3.328-3.312,7.024-4.464,11.392-0.896c10.48,7.168,37.488,12.544,39.392-5.648 C233.568,339.616,180.336,351.008,184.32,314.656z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M278.24,384c-4.224,0-8.832-2.32-8.832-7.936v-72.656c0-4.608,4.608-7.936,8.832-7.936h29.296 C366,295.472,364.72,384,308.688,384H278.24z M286.304,311.072v57.312h21.232c34.544,0,36.08-57.312,0-57.312H286.304z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "ai" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#F7B84E",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M164.224,384c-4.096-2.32-6.656-6.912-4.096-12.288l36.704-71.76c3.456-6.784,12.672-7.04,15.872,0 l36.064,71.76c5.248,9.968-10.24,17.904-14.832,7.936l-5.648-11.264h-47.2l-5.504,11.264C173.552,384,168.816,384.912,164.224,384z M219.216,351.504l-14.448-31.6l-15.728,31.6H219.216z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M264.048,303.152c0-10.496,16.896-10.88,16.896,0v73.024c0,10.624-16.896,10.88-16.896,0V303.152z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "cad" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#50BEE8",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M85.648,339.088c0-24.688,15.488-45.92,44.912-45.92c11.12,0,19.952,3.328,29.296,11.392 c3.456,3.184,3.824,8.832,0.368,12.4c-3.456,3.056-8.688,2.688-11.76-0.384c-5.248-5.504-10.624-7.024-17.904-7.024 c-19.696,0-29.168,13.952-29.168,29.552c0,15.872,9.344,30.448,29.168,30.448c7.28,0,14.064-2.944,19.952-8.192 c3.968-3.056,9.472-1.536,11.76,1.536c2.048,2.816,3.072,7.552-1.408,12.032c-8.96,8.32-19.696,9.984-30.32,9.984 C99.6,384.912,85.648,363.792,85.648,339.088z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M181.056,384c-4.096-2.304-6.656-6.912-4.096-12.288l36.704-71.76 c3.456-6.784,12.672-7.024,15.872,0l36.064,71.76c5.248,9.984-10.24,17.904-14.832,7.936l-5.648-11.264h-47.2l-5.504,11.264 C190.384,384,185.664,384.912,181.056,384z M236.064,351.52l-14.448-31.616l-15.728,31.616H236.064z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M289.264,384c-4.224,0-8.832-2.304-8.832-7.92v-72.672c0-4.608,4.608-7.936,8.832-7.936h29.296 c58.464,0,57.184,88.528,1.152,88.528H289.264z M297.328,311.072v57.312h21.232c34.544,0,36.08-57.312,0-57.312H297.328z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "html" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#84BD5A",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M55.68,376.064v-72.656c0-4.608,3.328-7.936,9.072-7.936c4.48,0,7.808,3.328,7.808,7.936v27.888 h41.696v-27.888c0-4.608,4.096-7.936,8.704-7.936c4.48,0,7.936,3.328,7.936,7.936v72.656c0,4.48-3.456,7.936-7.936,7.936 c-4.608,0-8.704-3.456-8.704-7.936v-28H72.56v28c0,4.48-3.328,7.936-7.808,7.936C59.008,384,55.68,380.544,55.68,376.064z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M172.784,311.472H150.4c-11.136,0-11.136-16.368,0-16.368h60.496c11.392,0,11.392,16.368,0,16.368 h-21.232v64.592c0,11.12-16.896,11.392-16.896,0v-64.592H172.784z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M248.688,327.84v47.328c0,5.648-4.608,8.832-9.2,8.832c-4.096,0-7.68-3.184-7.68-8.832v-72.016 c0-6.656,5.648-8.848,7.68-8.848c3.696,0,5.872,2.192,8.048,4.624l28.16,37.984l29.152-39.408c4.24-5.232,14.592-3.2,14.592,5.648 v72.016c0,5.648-3.6,8.832-7.68,8.832c-4.592,0-8.192-3.184-8.192-8.832V327.84l-21.232,26.864c-4.592,5.648-10.352,5.648-14.576,0 L248.688,327.84z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M337.264,303.152c0-4.224,3.584-7.808,8.064-7.808c4.096,0,7.552,3.6,7.552,7.808v64.096h34.8 c12.528,0,12.8,16.752,0,16.752h-42.336c-4.48,0-8.064-3.184-8.064-7.808v-73.04H337.264z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "css" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#576D7E",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M103.936,339.088c0-24.688,15.472-45.92,44.912-45.92c11.12,0,19.952,3.328,29.296,11.392 c3.456,3.184,3.824,8.816,0.368,12.4c-3.456,3.056-8.704,2.688-11.76-0.384c-5.248-5.504-10.624-7.024-17.904-7.024 c-19.696,0-29.168,13.952-29.168,29.552c0,15.872,9.344,30.448,29.168,30.448c7.28,0,14.064-2.96,19.952-8.192 c3.968-3.072,9.472-1.552,11.76,1.536c2.048,2.816,3.072,7.552-1.408,12.016c-8.96,8.336-19.696,10-30.32,10 C117.888,384.912,103.936,363.776,103.936,339.088z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M195.712,314.656c2.944-24.816,40.416-29.28,58.08-15.712c8.704,7.024-0.512,18.16-8.192,12.528 c-9.472-6.016-30.96-8.832-33.648,4.464c-3.456,20.992,52.192,8.976,51.296,42.992c-0.896,32.496-47.968,33.264-65.632,18.672 c-4.24-3.44-4.096-9.056-1.792-12.528c3.328-3.312,7.024-4.464,11.392-0.896c10.48,7.168,37.488,12.544,39.392-5.648 C244.976,339.616,191.744,351.008,195.712,314.656z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M276.48,314.656c2.944-24.816,40.416-29.28,58.08-15.712c8.704,7.024-0.512,18.16-8.192,12.528 c-9.472-6.016-30.96-8.832-33.648,4.464c-3.456,20.992,52.192,8.976,51.296,42.992c-0.896,32.496-47.968,33.264-65.632,18.672 c-4.224-3.44-4.096-9.056-1.792-12.528c3.328-3.312,7.024-4.464,11.392-0.896c10.48,7.168,37.488,12.544,39.408-5.648 C325.728,339.616,272.512,351.008,276.48,314.656z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : ["js", "jsx"].includes(h) ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#576D7E",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M193.744,303.152c0-10.752,16.896-10.752,16.896,0v50.528c0,20.08-9.6,32.24-31.712,32.24 c-10.88,0-19.968-2.96-27.888-13.168c-6.528-7.808,5.744-19.056,12.4-10.88c5.376,6.656,11.12,8.192,16.752,7.92 c7.168-0.256,13.44-3.456,13.568-16.112v-50.528H193.744z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M230.272,314.656c2.944-24.816,40.416-29.28,58.08-15.712c8.704,7.024-0.512,18.16-8.192,12.528 c-9.472-6.016-30.96-8.832-33.648,4.464c-3.456,20.992,52.192,8.976,51.296,42.992c-0.896,32.496-47.968,33.264-65.632,18.672 c-4.224-3.44-4.096-9.056-1.792-12.528c3.328-3.312,7.024-4.464,11.392-0.896c10.48,7.168,37.488,12.544,39.408-5.648 C279.52,339.616,226.304,351.008,230.272,314.656z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "php" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#576D7E",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M102.912,303.152c0-4.224,3.328-8.848,8.704-8.848h29.552c16.64,0,31.616,11.136,31.616,32.496 c0,20.224-14.976,31.472-31.616,31.472h-21.376v16.896c0,5.648-3.568,8.832-8.176,8.832c-4.224,0-8.704-3.184-8.704-8.832 C102.912,375.168,102.912,303.152,102.912,303.152z M119.792,310.432v31.856h21.36c8.576,0,15.36-7.552,15.36-15.488 c0-8.96-6.784-16.368-15.36-16.368L119.792,310.432L119.792,310.432z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M186.48,376.064v-72.656c0-4.608,3.328-7.936,9.088-7.936c4.464,0,7.792,3.328,7.792,7.936v27.888 h41.696v-27.888c0-4.608,4.096-7.936,8.704-7.936c4.464,0,7.936,3.328,7.936,7.936v72.656c0,4.48-3.472,7.936-7.936,7.936 c-4.608,0-8.704-3.456-8.704-7.936v-28H203.36v28c0,4.48-3.328,7.936-7.792,7.936C189.808,384,186.48,380.544,186.48,376.064z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M279.664,303.152c0-4.224,3.328-8.848,8.704-8.848h29.552c16.64,0,31.616,11.136,31.616,32.496 c0,20.224-14.976,31.472-31.616,31.472h-21.36v16.896c0,5.648-3.584,8.832-8.192,8.832c-4.224,0-8.704-3.184-8.704-8.832V303.152 L279.664,303.152z M296.56,310.432v31.856h21.36c8.576,0,15.36-7.552,15.36-15.488c0-8.96-6.784-16.368-15.36-16.368 L296.56,310.432L296.56,310.432z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "sql" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#F15642",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M98.128,314.672c2.944-24.832,40.416-29.296,58.064-15.728c8.704,7.024-0.496,18.16-8.192,12.528 c-9.456-6-30.96-8.816-33.648,4.464c-3.456,20.992,52.208,8.976,51.296,43.008c-0.896,32.496-47.968,33.248-65.632,18.672 c-4.224-3.456-4.096-9.072-1.776-12.544c3.312-3.312,7.024-4.464,11.376-0.88c10.496,7.152,37.488,12.528,39.408-5.648 C147.376,339.632,94.16,351.008,98.128,314.672z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M265.488,369.424l2.048,2.416c8.432,7.68-2.56,20.224-11.136,12.16l-4.336-3.44 c-6.656,4.592-14.448,6.784-24.816,6.784c-22.512,0-48.24-15.504-48.24-46.976s25.584-47.456,48.24-47.456 c23.776,0,47.072,15.984,47.072,47.456C274.32,352.528,271.232,361.504,265.488,369.424z M257.792,340.368 c0-20.336-15.984-30.688-30.56-30.688c-15.728,0-31.216,10.336-31.216,30.688c0,15.504,13.168,30.208,31.216,30.208 c4.592,0,9.072-1.152,13.552-2.304l-14.576-13.44c-6.784-8.192,3.968-19.84,12.528-12.288l14.464,14.448 C256.384,352.528,257.792,347.024,257.792,340.368z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M293.168,303.152c0-4.224,3.584-7.808,8.064-7.808c4.096,0,7.552,3.6,7.552,7.808v64.096h34.8 c12.528,0,12.8,16.752,0,16.752h-42.336c-4.48,0-8.064-3.184-8.064-7.792v-73.056H293.168z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "xml" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#50BEE8",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M131.28,326.176l22.272-27.888c6.64-8.688,19.568,2.432,12.288,10.752 c-7.664,9.088-15.728,18.944-23.424,29.024l26.112,32.496c7.024,9.6-7.04,18.816-13.952,9.344l-23.536-30.192l-23.152,30.832 c-6.528,9.328-20.992-1.152-13.68-9.856l25.712-32.624c-8.064-10.096-15.872-19.936-23.664-29.024 c-8.064-9.6,6.912-19.44,12.784-10.48L131.28,326.176z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M201.264,327.84v47.328c0,5.648-4.608,8.832-9.2,8.832c-4.096,0-7.68-3.184-7.68-8.832v-72.016 c0-6.656,5.648-8.848,7.68-8.848c3.696,0,5.872,2.192,8.048,4.624l28.16,37.984l29.152-39.408c4.24-5.232,14.592-3.2,14.592,5.648 v72.016c0,5.648-3.584,8.832-7.664,8.832c-4.608,0-8.192-3.184-8.192-8.832V327.84l-21.248,26.864 c-4.592,5.648-10.352,5.648-14.576,0L201.264,327.84z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M294.288,303.152c0-4.224,3.584-7.808,8.064-7.808c4.096,0,7.552,3.6,7.552,7.808v64.096h34.8 c12.528,0,12.8,16.752,0,16.752h-42.336c-4.48,0-8.064-3.184-8.064-7.808v-73.04H294.288z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : ["jpg", "jpeg"].includes(h) ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#50BEE8",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M141.968,303.152c0-10.752,16.896-10.752,16.896,0v50.528c0,20.096-9.6,32.256-31.728,32.256 c-10.88,0-19.952-2.96-27.888-13.184c-6.528-7.808,5.76-19.056,12.416-10.88c5.376,6.656,11.136,8.192,16.752,7.936 c7.152-0.256,13.44-3.472,13.568-16.128v-50.528H141.968z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M181.344,303.152c0-4.224,3.328-8.832,8.704-8.832H219.6c16.64,0,31.616,11.136,31.616,32.48 c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.704-3.184-8.704-8.816 L181.344,303.152L181.344,303.152z M198.24,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504 c0-8.944-6.784-16.368-15.36-16.368H198.24z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M342.576,374.16c-9.088,7.552-20.224,10.752-31.472,10.752c-26.88,0-45.936-15.344-45.936-45.808 c0-25.824,20.096-45.904,47.072-45.904c10.112,0,21.232,3.44,29.168,11.248c7.792,7.664-3.456,19.056-11.12,12.288 c-4.736-4.608-11.392-8.064-18.048-8.064c-15.472,0-30.432,12.4-30.432,30.432c0,18.944,12.528,30.464,29.296,30.464 c7.792,0,14.448-2.32,19.184-5.76V348.08h-19.184c-11.392,0-10.24-15.616,0-15.616h25.584c4.736,0,9.072,3.584,9.072,7.552v27.248 C345.76,369.568,344.752,371.712,342.576,374.16z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "png" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#A066AA",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M92.816,303.152c0-4.224,3.312-8.848,8.688-8.848h29.568c16.624,0,31.6,11.136,31.6,32.496 c0,20.224-14.976,31.472-31.6,31.472H109.68v16.896c0,5.648-3.552,8.832-8.176,8.832c-4.224,0-8.688-3.184-8.688-8.832 C92.816,375.168,92.816,303.152,92.816,303.152z M109.68,310.432v31.856h21.376c8.56,0,15.344-7.552,15.344-15.488 c0-8.96-6.784-16.368-15.344-16.368L109.68,310.432L109.68,310.432z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M178.976,304.432c0-4.624,1.024-9.088,7.68-9.088c4.592,0,5.632,1.152,9.072,4.464l42.336,52.976 v-49.632c0-4.224,3.696-8.848,8.064-8.848c4.608,0,9.072,4.624,9.072,8.848v72.016c0,5.648-3.456,7.792-6.784,8.832 c-4.464,0-6.656-1.024-10.352-4.464l-42.336-53.744v49.392c0,5.648-3.456,8.832-8.064,8.832s-8.704-3.184-8.704-8.832v-70.752 H178.976z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M351.44,374.16c-9.088,7.536-20.224,10.752-31.472,10.752c-26.88,0-45.936-15.36-45.936-45.808 c0-25.84,20.096-45.92,47.072-45.92c10.112,0,21.232,3.456,29.168,11.264c7.808,7.664-3.456,19.056-11.12,12.288 c-4.736-4.624-11.392-8.064-18.048-8.064c-15.472,0-30.432,12.4-30.432,30.432c0,18.944,12.528,30.448,29.296,30.448 c7.792,0,14.448-2.304,19.184-5.76V348.08h-19.184c-11.392,0-10.24-15.632,0-15.632h25.584c4.736,0,9.072,3.6,9.072,7.568v27.248 C354.624,369.552,353.616,371.712,351.44,374.16z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "gif" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#A066AA",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M199.84,374.16c-9.088,7.536-20.224,10.752-31.472,10.752c-26.88,0-45.936-15.36-45.936-45.808 c0-25.84,20.096-45.92,47.072-45.92c10.112,0,21.232,3.456,29.168,11.264c7.808,7.664-3.456,19.056-11.12,12.288 c-4.736-4.624-11.392-8.064-18.048-8.064c-15.472,0-30.432,12.4-30.432,30.432c0,18.944,12.528,30.448,29.296,30.448 c7.792,0,14.448-2.304,19.184-5.76V348.08h-19.184c-11.392,0-10.24-15.632,0-15.632h25.584c4.736,0,9.072,3.6,9.072,7.568v27.248 C203.024,369.552,202.016,371.712,199.84,374.16z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M224.944,303.152c0-10.496,16.896-10.88,16.896,0v73.024c0,10.624-16.896,10.88-16.896,0V303.152z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M281.12,312.096v20.336h32.608c4.608,0,9.216,4.608,9.216,9.088c0,4.224-4.608,7.664-9.216,7.664 H281.12v26.864c0,4.48-3.2,7.936-7.68,7.936c-5.632,0-9.072-3.456-9.072-7.936v-72.656c0-4.608,3.456-7.936,9.072-7.936h44.912 c5.632,0,8.96,3.328,8.96,7.936c0,4.096-3.328,8.688-8.96,8.688H281.12V312.096z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "svg" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#F7B84E",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M96.816,314.656c2.944-24.816,40.416-29.28,58.08-15.712c8.704,7.024-0.512,18.16-8.192,12.528 c-9.472-6.016-30.96-8.832-33.648,4.464c-3.456,20.992,52.192,8.976,51.312,42.992c-0.896,32.496-47.984,33.264-65.648,18.672 c-4.224-3.44-4.096-9.056-1.792-12.528c3.328-3.312,7.04-4.464,11.392-0.896c10.48,7.168,37.488,12.544,39.392-5.648 C146.064,339.616,92.848,351.008,96.816,314.656z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M209.12,378.256l-33.776-70.752c-4.992-10.112,10.112-18.416,15.728-7.808l11.392,25.712 l14.704,33.776l14.448-33.776l11.392-25.712c5.12-9.712,19.952-3.584,15.616,7.04L226,378.256 C223.056,386.32,213.984,388.224,209.12,378.256z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M345.76,374.16c-9.088,7.536-20.224,10.752-31.472,10.752c-26.88,0-45.936-15.36-45.936-45.808 c0-25.84,20.096-45.92,47.072-45.92c10.112,0,21.232,3.456,29.168,11.264c7.792,7.664-3.456,19.056-11.12,12.288 c-4.736-4.624-11.392-8.064-18.048-8.064c-15.472,0-30.432,12.4-30.432,30.432c0,18.944,12.528,30.448,29.296,30.448 c7.792,0,14.448-2.304,19.184-5.76V348.08h-19.184c-11.392,0-10.24-15.632,0-15.632h25.584c4.736,0,9.072,3.6,9.072,7.568v27.248 C348.96,369.552,347.936,371.712,345.76,374.16z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "iso" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#50BEE8",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M119.52,303.152c0-10.496,16.896-10.88,16.896,0v73.024c0,10.624-16.896,10.88-16.896,0 C119.52,376.176,119.52,303.152,119.52,303.152z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M156.624,314.656c2.944-24.816,40.416-29.28,58.08-15.712c8.704,7.024-0.512,18.16-8.192,12.528 c-9.472-6.016-30.96-8.832-33.648,4.464c-3.456,20.992,52.192,8.976,51.296,42.992c-0.896,32.496-47.968,33.264-65.632,18.672 c-4.24-3.44-4.096-9.056-1.792-12.528c3.328-3.312,7.024-4.464,11.392-0.896c10.48,7.168,37.488,12.544,39.392-5.648 C205.872,339.616,152.656,351.008,156.624,314.656z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M285.824,385.28c-23.664,1.024-48.24-14.72-48.24-46.064c0-31.472,24.56-46.944,48.24-46.944 c22.384,1.136,45.792,16.624,45.792,46.944C331.632,369.552,308.224,385.28,285.824,385.28z M284.416,308.912 c-14.336,0-29.936,10.112-29.936,30.32c0,20.096,15.616,30.336,29.936,30.336c14.72,0,30.448-10.24,30.448-30.336 C314.88,319.008,299.136,308.912,284.416,308.912z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : h === "zip" ? /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#84BD5A",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ l("g", { children: [
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M132.64,384c-8.064,0-11.264-7.792-6.656-13.296l45.552-60.512h-37.76 c-11.12,0-10.224-15.712,0-15.712h51.568c9.712,0,12.528,9.184,5.632,16.624l-43.632,56.656h41.584 c10.24,0,11.52,16.256-1.008,16.256h-55.28V384z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M212.048,303.152c0-10.496,16.896-10.88,16.896,0v73.04c0,10.608-16.896,10.88-16.896,0V303.152z"
            }
          ),
          " ",
          /* @__PURE__ */ c(
            "path",
            {
              fill: "#FFFFFF",
              d: "M251.616,303.152c0-4.224,3.328-8.832,8.704-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48 c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.704-3.184-8.704-8.816 L251.616,303.152L251.616,303.152z M268.496,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504 c0-8.944-6.784-16.368-15.36-16.368H268.496z"
            }
          ),
          " "
        ] }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
) : /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#000000",
    children: [
      /* @__PURE__ */ c("g", { strokeWidth: "0" }),
      /* @__PURE__ */ c("g", { strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ l("g", { children: [
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E2E5E7",
            d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
          }
        ),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#B0B7BD",
            d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
          }
        ),
        " ",
        /* @__PURE__ */ c("polygon", { fill: "#CAD1D8", points: "480,224 384,128 480,128 " }),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#576D7E",
            d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
          }
        ),
        " ",
        /* @__PURE__ */ c("g", {}),
        " ",
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#CAD1D8",
            d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
          }
        ),
        " "
      ] })
    ]
  }
);
export {
  d as ExtIcon
};
